import { footerColumns, footerTags } from "@/mocks/home";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-background-100">
      <div className="h-1 w-full bg-primary-500" />
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-line text-lg text-background-50" />
              </span>
              <span className="font-logo text-2xl text-foreground-950">黑料一区</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              黑料一区，新瓜速递，今日最新瓜快看。我们聚合热门爆料并标注来源，
              让速看新料不迷路，也让每一次讨论都建立在可核实的信息之上。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-800">
                <i className="ri-shield-check-line" />
                来源标注
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                <i className="ri-time-line" />
                实时更新
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-800">
                <i className="ri-user-heart-line" />
                社区共建
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3 lg:col-span-8">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-base font-bold text-foreground-950">
                  <a href="#top" className="transition-colors hover:text-primary-700">
                    {column.title}
                  </a>
                </h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 border-t border-background-200 pt-6">
          <h4 className="font-heading text-base font-bold text-foreground-950">站内热词</h4>
          <div className="mt-4 flex flex-wrap gap-2">
            {footerTags.map((tag) => (
              <a
                key={tag}
                href="#stream"
                className="rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {tag}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-primary-600">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-50 md:flex-row md:px-8">
          <p>© {year} 黑料一区 · 内容仅作信息聚合与整理，请理性看待未经证实的线索。</p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <a href="#trust" className="transition-colors hover:text-secondary-200">内容说明</a>
            <a href="#faq" className="transition-colors hover:text-secondary-200">常见问题</a>
            <a
              href="#top"
              className="inline-flex items-center gap-1 transition-colors hover:text-secondary-200"
            >
              回到顶部
              <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}